import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { TableHeader } from './TableHeader';
import { TABLE_STYLES } from '../../consts/styles';
import { ITableProps } from './types';
import { TableBody } from './TableBody';
import { TableEmptyState } from './TableEmptyState';

export const Table = ({ name, title, titleAddon, columns, data, testId, isLoading }: ITableProps) => (
  <div data-testid={testId}>
    <div className={TABLE_STYLES.TableTitle}>
      {title}
      {titleAddon && <span className={TABLE_STYLES.TableTitleAddon}>{titleAddon}</span>}
    </div>
    <div>
      {/** @ts-ignore */}
      <table style={{ border: 0 }} className='w-full relative select-none' cellSpacing={0} cellPadding={0}>
        <colgroup>
          <col className='w-[145px]' />
          <col className='w-[28%]' />
          <col className='' />
          <col className='w-[100px]' />
          <col className='w-[145px]' />
          <col className='w-[80px]' />
        </colgroup>
        <TableHeader columns={columns} />
        {!isLoading && <TableBody columns={columns} data={data} />}
      </table>
      {isLoading && (
        <div className='border border-bw03 border-t-[0] rounded-b-lg'>
          <Skeleton className='h-[64px] w-full' count={5} />
        </div>
      )}
      {!isLoading && data?.length === 0 && <TableEmptyState name={name} />}
    </div>
  </div>
);
